import Swiper, { Navigation, Autoplay }  from 'swiper';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const CompaniesCarousel = ($, context) => {

  var $swiper;
  const $target = $('.companies-carousel .swiper', context)

  var self = {
    init: () => {
      /* Is there at least one carousel on the page? */
      if($target.length == 0)
          return

      /* Init all carousels */
      $target.each( (i) => {
        const carousel = $target[i]
        $swiper = new Swiper(carousel, {
          modules: [Navigation, Autoplay],
          slidesPerView: "auto",
          spaceBetween: 0,
          loop: true,
          navigation: {
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
          },
        })
      })

    }
  }

  return self;
}

export default CompaniesCarousel